import { render, staticRenderFns } from "./ResellerList.vue?vue&type=template&id=d275d786"
import script from "./ResellerList.vue?vue&type=script&lang=js"
export * from "./ResellerList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports